import { MexusEntity } from '../../mexus-entity'

export class AttachmentSpec {
  public type: AttachmentSpecType = AttachmentSpecType.DESIGN_IMAGE
  public typeId: string
  public labels: string[] = []
  public scope: MexusEntity
}

export enum AttachmentSpecType {
  DESIGN_IMAGE = 'DESIGN_IMAGE',
  SEGMENT_IMAGE = 'SEGMENT_IMAGE',
  REMOTE_ATTACHMENT = 'REMOTE_ATTACHMENT',
}
